@import '~style-sheet-helpers/core.less';

.language-selection-modal {
  width: 600px;
}

.modal-body {
  padding: 20px;
  overflow: auto;
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 14px;
  line-height: 16px;
  .language-selection-dropdown {
    width: 210px;
    label {
      font-weight: @bold;
      margin: 15px 0 5px;
      display: block;
    }
  }
}

.modal-footer {
  > button {
    margin-left: 10px;
    width: 85px;
  }
}
